import { render, staticRenderFns } from "./toggle-button.vue?vue&type=template&id=e01487c2"
import script from "./toggle-button.vue?vue&type=script&lang=js"
export * from "./toggle-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports